import React, { useEffect } from 'react';
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { TableRow, Checkbox, Chip, TextField, ThemeProvider, createTheme, Tooltip, Typography,InputAdornment  } from '@mui/material';
import { stableSort, getComparator } from '../../common/SortSupport';
import { EnhancedTableHead } from '../EnhancedTableHead';
import { Box } from '@mui/material';
import ActionDetailPopper from '../../containers/ActionDetailPopper';
import { staffList } from '../../assets/staticData';
import YenTextField from '../YenTextField';
import { useDispatch, useSelector } from 'react-redux';
import StaffDetailPage from '../../containers/StaffDetailPage';
import { useTranslation } from 'react-i18next';
import { getClubDepartments } from '../../api/club';
import { employmentStatusNaming } from '../../api/typesDc';
import { setDepartments } from '../../redux/reducers/licence';
import { resetSelectedStaff, setIsUpdatedStaff, setSelectedStaff, setStaffDetails } from '../../redux/reducers/dataCaptures';
import { deleteStaff, saveStaffDetails } from '../../api/dataCapture';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const theme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          display: 'inline',
          width: '90px'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: '90px !important',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: 18,
          height: 18
        }
      }
    }
  },
})

const StaffListTable = () => {

  //supporting contents
  const [order, setOrder] = React.useState('');
  const [orderBy, setOrderBy] = React.useState('');

  const data = useSelector((state:any) => state.dataCaptures.staffDetails);
  const departments = useSelector((state:any) => state.licence.departments);
  const clubDetails = useSelector((state:any) => state.clubDetails);
  const isAdmin = useSelector((state:any) => state.common.isAdmin);
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const visibleRows = React.useMemo(
    () =>
      data?.length > 0 &&
      stableSort(data, getComparator(order, orderBy)),
    [order, orderBy, data],
  );

  const head = [
    {
        key: '', displayName: t('NAME'),
    },
    {
        key: '', displayName: t('DC_5_JOB_TITLE'),
    },
    {
        key: '', displayName: t('DEPARTMENT'),
    },
    {
        key: '', displayName: 'contract type',
    },
    {
        key: '', displayName: '',
    },
  ]
  
  const fetchDepartments = async () => {
      const response = await getClubDepartments({clubId: clubDetails.id});
      dispatch(setDepartments(response));
  }

  useEffect(() => {
    !departments && clubDetails && clubDetails?.id && fetchDepartments()
  }, [departments, clubDetails]);

  const getDepartments = (departmentIds:any) => {
    if (!departmentIds || !departments || departments?.length === 0) return '';
    const departmentNames = departmentIds.map((id: string) => {
      const department = departments.find((dept: any) => dept.id == id);
      return department ? department.name : '';
    });
    return departmentNames.join(', ');
  }
  
  const manageDeleteRow = (row:any) => {
    deleteStaff({ clubId: clubDetails?.id, id: row?.id })
    .then(() => {
      const tempData = data?.filter((item:any) => item?.id != row?.id);
      dispatch(setStaffDetails(tempData));
    });
  }

  //table contents
    return(
        <React.Fragment>
          <ThemeProvider theme={theme}>
          <Box sx={{ position: 'relative' }}>
              <TableContainer>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    tableHeads={head}
                    bg={'#FAFAFA'}
                    />
                    <TableBody>
                    {
                        visibleRows && visibleRows?.length &&
                    visibleRows?.map((d: any, i: number) => {
                      const employmentStatusKey = d?.employmentStatus as keyof typeof employmentStatusNaming;
                      return (
                        <TableRow
                          className='hoverBG'
                          sx={{ cursor: 'pointer' }}
                          key={`accountingpl-table-row-${i}`}
                          onClick={() => {dispatch(setSelectedStaff(d));}}
                        >
                          <TableCell className='fs12'>
                              {d.kanjiName}
                          </TableCell>
                          <TableCell className='fs12'>
                              {d.jobTitle}
                          </TableCell>
                          <TableCell className='fs12'>
                            {getDepartments(d?.department)}
                          </TableCell>
                          <TableCell className='fs12'>
                            {t(employmentStatusNaming[employmentStatusKey])}
                          </TableCell>
                          <TableCell>
                            <Tooltip title='Delete' arrow placement='top'>
                              <FontAwesomeIcon onClick={(e:any) => {e.stopPropagation(); !isAdmin && manageDeleteRow(d);}} className={isAdmin ? 'icon mr10 deleteIcon cursorNotAllowed' : 'icon mr10 deleteIcon'} icon={faTrash}/>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      )
                    })}
                    </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </ThemeProvider>
        </React.Fragment>
    )
}

export default StaffListTable;